module.exports = __webpack_public_path__ + "img/btn-serch-blue.d80aa7c3.svg";